module.exports = __webpack_public_path__ + "static/media/google-play-badge.bf32cb6f.png";